import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "community-page" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { "aria-current": "page" }
const _hoisted_4 = {
  key: 0,
  class: "eyebrow"
}
const _hoisted_5 = { class: "intro" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = {
  id: "community-panel-servers",
  role: "tabpanel",
  "aria-labelledby": "community-tab-servers",
  tabindex: "0"
}
const _hoisted_8 = { class: "section-heading" }
const _hoisted_9 = { id: "servers-title" }
const _hoisted_10 = { class: "server-count" }
const _hoisted_11 = { class: "server-list" }
const _hoisted_12 = ["aria-labelledby"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "server-details" }
const _hoisted_15 = { class: "server-heading" }
const _hoisted_16 = ["id"]
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = { class: "description" }
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = ["lang"]
const _hoisted_21 = { "aria-hidden": "true" }
const _hoisted_22 = ["href", "rel"]
const _hoisted_23 = { class: "sr-only" }
const _hoisted_24 = {
  key: 1,
  class: "resource-promotion",
  "aria-labelledby": "promotion-title"
}
const _hoisted_25 = { class: "promotion-heading" }
const _hoisted_26 = { class: "promotion-label" }
const _hoisted_27 = { id: "promotion-title" }
const _hoisted_28 = { class: "promotion-footer" }
const _hoisted_29 = { class: "promotion-note" }
const _hoisted_30 = ["id", "aria-labelledby"]
const _hoisted_31 = {
  class: "discovery-guide",
  "aria-labelledby": "discovery-title"
}
const _hoisted_32 = { id: "discovery-title" }
const _hoisted_33 = ["aria-label"]
const _hoisted_34 = ["aria-label"]

import { languageFlags } from './board-display';
import { computed, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { localizedPath } from '@/router/paths';
import { useI18n } from 'vue-i18n';
import { communityServers } from './servers';
import PlayerBoards from './PlayerBoards.vue';

type CommunityTab = (typeof tabs)[number]['value'];

export default /*@__PURE__*/_defineComponent({
  __name: 'Community',
  setup(__props) {

const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();
const boardKinds = ['solo', 'group'] as const;
const tabs = [
  { value: 'servers', label: 'playerBoards.communities', route: 'community' },
  { value: 'solo', label: 'playerBoards.players', route: 'community_solo' },
  { value: 'group', label: 'playerBoards.teams', route: 'community_group' },
] as const;
const activeTab = computed<CommunityTab>(() =>
  route.path.includes('/community/players') ? 'solo' : route.path.includes('/community/groups') ? 'group' : 'servers',
);
async function onTabKey(event: KeyboardEvent, current: CommunityTab) {
  const index = tabs.findIndex((tab) => tab.value === current);
  let next: number;
  if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
  else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
  else if (event.key === 'Home') next = 0;
  else if (event.key === 'End') next = tabs.length - 1;
  else return;
  event.preventDefault();
  const container = (event.currentTarget as HTMLElement).parentElement;
  await router.push(localizedPath(router.resolve({ name: tabs[next].route }).path, locale.value));
  await nextTick();
  container?.querySelectorAll<HTMLElement>('[role="tab"]')[next]?.focus();
}
// Keep the placement offer below official servers and above community listings.
const directoryEntries = [
  ...communityServers.filter((server) => server.official).map((server) => ({ server })),
  { server: null },
  ...communityServers.filter((server) => !server.official).map((server) => ({ server })),
];

return (_ctx: any,_cache: any) => {
  const _component_LocaleLink = _resolveComponent("LocaleLink")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", {
      class: _normalizeClass(["community-hero", { 'community-hero--compact': activeTab.value !== 'servers' }])
    }, [
      _createElementVNode("nav", {
        class: "community-breadcrumbs",
        "aria-label": _unref(t)('community.title')
      }, [
        _createVNode(_component_LocaleLink, { to: { name: 'lobby' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('menu.home')), 1)
          ]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("span", { "aria-hidden": "true" }, "/", -1)),
        _createVNode(_component_LocaleLink, {
          to: { name: 'community' },
          "aria-current": activeTab.value === 'servers' ? 'page' : undefined
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('community.title')), 1)
          ]),
          _: 1
        }, 8, ["aria-current"]),
        (activeTab.value !== 'servers')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { "aria-hidden": "true" }, "/", -1)),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)(`playerBoards.${activeTab.value === 'solo' ? 'players' : 'teams'}`)), 1)
            ], 64))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2),
      (activeTab.value === 'servers')
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "AVALON · " + _toDisplayString(_unref(t)('community.eyebrow')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("h1", null, _toDisplayString(_unref(t)(
            activeTab.value === 'servers'
              ? 'community.title'
              : `playerBoards.${activeTab.value === 'solo' ? 'findPlayers' : 'findCompany'}`,
          )), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)(
            activeTab.value === 'servers'
              ? 'community.intro'
              : `playerBoards.${activeTab.value === 'solo' ? 'browsePlayersIntro' : 'browseTeamsIntro'}`,
          )), 1)
    ], 2),
    _createElementVNode("div", {
      class: "community-tabs",
      role: "tablist",
      "aria-label": _unref(t)('community.title')
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
        return _createVNode(_component_LocaleLink, {
          id: `community-tab-${tab.value}`,
          key: tab.value,
          to: { name: tab.route },
          role: "tab",
          "aria-selected": activeTab.value === tab.value,
          "aria-controls": `community-panel-${tab.value}`,
          tabindex: activeTab.value === tab.value ? 0 : -1,
          onKeydown: ($event: any) => (onTabKey($event, tab.value))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)(tab.label)), 1)
          ]),
          _: 2
        }, 1032, ["id", "to", "aria-selected", "aria-controls", "tabindex", "onKeydown"])
      }), 64))
    ], 8, _hoisted_6),
    _withDirectives(_createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h2", _hoisted_9, _toDisplayString(_unref(t)('community.servers')), 1),
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(communityServers).length), 1)
      ]),
      _createElementVNode("ul", _hoisted_11, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(directoryEntries, ({ server }) => {
          return _createElementVNode("li", {
            key: server?.id ?? 'promotion'
          }, [
            server
              ? (_openBlock(), _createElementBlock("article", {
                  key: 0,
                  class: "server-card",
                  "aria-labelledby": `server-${server.id}`
                }, [
                  _createElementVNode("img", {
                    class: "server-logo",
                    src: server.logo,
                    alt: "",
                    width: "88",
                    height: "88"
                  }, null, 8, _hoisted_13),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("h3", {
                        id: `server-${server.id}`
                      }, _toDisplayString(server.name), 9, _hoisted_16),
                      (server.official)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "official",
                            "aria-label": _unref(t)('community.official')
                          }, [
                            _cache[2] || (_cache[2] = _createElementVNode("span", {
                              class: "material-icons",
                              "aria-hidden": "true"
                            }, "verified", -1)),
                            _createTextVNode(" " + _toDisplayString(_unref(t)('community.official')), 1)
                          ], 8, _hoisted_17))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)(server.descriptionKey)), 1),
                    _createElementVNode("ul", {
                      class: "language-tags",
                      "aria-label": _unref(t)('community.languages')
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(server.languages, (language) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: language.code,
                          lang: language.code
                        }, [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(languageFlags)[language.code]), 1),
                          _createTextVNode(" " + _toDisplayString(language.label), 1)
                        ], 8, _hoisted_20))
                      }), 128))
                    ], 8, _hoisted_19)
                  ]),
                  _createElementVNode("a", {
                    class: "join-link",
                    href: server.messenger.url,
                    target: "_blank",
                    rel: server.sponsored ? 'sponsored noopener noreferrer' : 'noopener noreferrer'
                  }, [
                    _createVNode(_component_v_icon, {
                      icon: server.messenger.icon,
                      size: "20",
                      "aria-hidden": "true"
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('community.join', { messenger: server.messenger.name })) + " ", 1),
                    _cache[3] || (_cache[3] = _createElementVNode("span", {
                      class: "material-icons",
                      "aria-hidden": "true"
                    }, "north_east", -1)),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(t)('community.newTab')), 1)
                  ], 8, _hoisted_22)
                ], 8, _hoisted_12))
              : (_openBlock(), _createElementBlock("aside", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", {
                        class: "material-icons",
                        "aria-hidden": "true"
                      }, "campaign", -1)),
                      _createTextVNode(_toDisplayString(_unref(t)('community.promotionLabel')), 1)
                    ]),
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "promotion-price" }, "$50+", -1))
                  ]),
                  _createElementVNode("h3", _hoisted_27, _toDisplayString(_unref(t)('community.promotionTitle')), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('community.promotionText')), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_LocaleLink, {
                      class: "promotion-link",
                      to: { name: 'support' }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('community.promotionAction')) + " ", 1),
                        _cache[6] || (_cache[6] = _createElementVNode("span", {
                          class: "material-icons",
                          "aria-hidden": "true"
                        }, "arrow_forward", -1))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('community.promotionNote')), 1)
                  ])
                ]))
          ])
        }), 64))
      ])
    ], 512), [
      [_vShow, activeTab.value === 'servers']
    ]),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(boardKinds, (board) => {
      return _withDirectives(_createElementVNode("section", {
        id: `community-panel-${board}`,
        key: board,
        role: "tabpanel",
        "aria-labelledby": `community-tab-${board}`,
        tabindex: "0"
      }, [
        (activeTab.value === board)
          ? (_openBlock(), _createBlock(PlayerBoards, {
              key: 0,
              kind: board
            }, null, 8, ["kind"]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_30), [
        [_vShow, activeTab.value === board]
      ])
    }), 64)),
    _createElementVNode("section", _hoisted_31, [
      _createElementVNode("h2", _hoisted_32, _toDisplayString(_unref(t)('playerBoards.discoveryTitle')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('playerBoards.discoveryHow')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)(activeTab.value === 'group' ? 'playerBoards.discoveryGroup' : 'playerBoards.discoverySolo')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('playerBoards.discoveryLifetime')), 1),
      _createElementVNode("nav", {
        class: "discovery-links",
        "aria-label": _unref(t)('community.title')
      }, [
        _createVNode(_component_LocaleLink, { to: { name: 'community_solo' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('playerBoards.seoSoloTitle')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_LocaleLink, { to: { name: 'community_group' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('playerBoards.seoGroupTitle')), 1)
          ]),
          _: 1
        })
      ], 8, _hoisted_33),
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('playerBoards.discoveryNew')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('playerBoards.discoveryLearn')), 1),
      _createElementVNode("nav", {
        class: "discovery-links",
        "aria-label": _unref(t)('menu.wiki')
      }, [
        _createVNode(_component_LocaleLink, { to: { name: 'rules' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('wiki.rules')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_LocaleLink, { to: { name: 'roles' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('wiki.roles')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_LocaleLink, { to: { name: 'social_deduction_games_online' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('wiki.gameGuides')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_LocaleLink, { to: { name: 'lobby' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('menu.home')), 1)
          ]),
          _: 1
        })
      ], 8, _hoisted_34)
    ])
  ]))
}
}

})